// Shared user-sort helper — used by both the Login user grid and the Team
// management page so the ordering feels consistent everywhere.
//
// Order:
//   1. Active users first (inactive fall to the bottom).
//   2. By role: Warehouse Manager → Operations Manager → Staff → anything else.
//   3. By primary department (alphabetical; users without a dept fall last).
//   4. By name (alphabetical, case-insensitive).

const ROLE_ORDER = {
  warehouse_manager: 0,
  operations_manager: 1,
  staff: 2,
};

const _firstDept = (u) => {
  const d = Array.isArray(u.departments) ? u.departments : [];
  return (d[0] || "").toLowerCase();
};

export const sortUsersByRole = (users) =>
  [...(users || [])].sort((a, b) => {
    const activeA = a.is_active === false ? 1 : 0;
    const activeB = b.is_active === false ? 1 : 0;
    if (activeA !== activeB) return activeA - activeB;

    const roleA = ROLE_ORDER[a.role] ?? 9;
    const roleB = ROLE_ORDER[b.role] ?? 9;
    if (roleA !== roleB) return roleA - roleB;

    const deptA = _firstDept(a);
    const deptB = _firstDept(b);
    if (deptA && !deptB) return -1;
    if (deptB && !deptA) return 1;
    if (deptA !== deptB) return deptA.localeCompare(deptB);

    return (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase());
  });
